import { MutationCache, QueryClient, type QueryKey } from "@tanstack/react-query";

import { purchaseQueryKeys } from "./queryKeys";

type PurchaseMutationMeta = {
  skipGlobalInvalidation?: boolean;
  invalidateQueryKeys?: QueryKey[];
};

async function invalidateAfterMutation(queryClient: QueryClient, meta: PurchaseMutationMeta | undefined) {
  if (meta?.skipGlobalInvalidation === true) {
    return;
  }

  if (meta?.invalidateQueryKeys?.length) {
    const queryKeys = [...meta.invalidateQueryKeys, purchaseQueryKeys.dashboard.all];
    await Promise.all(
      queryKeys.map((queryKey) =>
        queryClient.invalidateQueries({
          queryKey,
          refetchType: "active",
        }),
      ),
    );
    return;
  }

  await queryClient.invalidateQueries({ refetchType: "active" });
}

export function createPurchaseQueryClient() {
  let queryClient: QueryClient;

  queryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: async (_data, _variables, _context, mutation) => {
        await invalidateAfterMutation(queryClient, mutation.options.meta as PurchaseMutationMeta | undefined);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60000,
        retry: 2,
        refetchOnWindowFocus: true,
      },
    },
  });

  return queryClient;
}
